/*
 * MEPP - A web application to guide patients and clinicians in the process of
 * facial palsy rehabilitation, with the help of the mirror effect and principles
 * of motor learning
 * Copyright (C) 2021 MEPP <info@mirroreffectplus.org>
 *
 * This file is part of MEPP.
 *
 * MEPP is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * MEPP is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with MEPP.  If not, see <http://www.gnu.org/licenses/>.
 */

export default {
  intro: {
    title: 'Hola {{name}}',
    introduction:
      '¿Listo(a) para comenzar su sesión de ejercicios? Concéntrese en las contracciones musculares y trate de sentirlas, aunque no vea nada moverse. Deje el resto de la cara en reposo.',
    instruction:
      'Realiza los ejercicios lentamente siguiendo el ritmo propuesto.',
  },
  permission: {
    title: 'Permiso',
    introduction:
      'Para poder continuar con su sesión, debe permitir el acceso de esta página web a su cámara y a su micrófono.',
    instruction:
      'Para acceder a su sesión, primero deberá autorizarla modificando la configuración de su navegador.',
  },
};
